export default __webpack_public_path__ + "media/zurb/img/events/wired/raft/raft-1-544f7131c37fbed0dba3d53aad9fee47.jpg";